import { type NavigateOptions, useNavigate } from "react-router";

function useNavigateWEB() {
	const navigate = useNavigate();

	return (link: string | number, options?: NavigateOptions) => {
		if (typeof link === "number") {
			navigate(link);
		} else {
			navigate(link, { relative: "path", ...options });
		}
	};
}
export default useNavigateWEB;
